export default "__VITE_ASSET__DthOjDXV__"